import React from 'react';
import PropTypes from 'prop-types';

import {
  AccordionTitleText,
  Icon,
} from './styles';

const AccordionTitle = (props) => {
  const {
    isExpanded,
    title,
    handleRowClick,
  } = props;

  return (
    <AccordionTitleText
      onClick={handleRowClick}
    >
      <Icon name={isExpanded ? 'caret down' : 'caret right'} />
      {title}
    </AccordionTitleText>
  );
};

AccordionTitle.propTypes = {
  isExpanded: PropTypes.bool,
  title: PropTypes.string.isRequired,
  handleRowClick: PropTypes.func,
};

AccordionTitle.defaultProps = {
  isExpanded: false,
  handleRowClick: () => {},
};

export default AccordionTitle;
